export const namespaced = true;
import _ from 'lodash';
import Vue from 'vue'

const mapLayersTmp =  [
    {
      "name": "Basic",
      "style": "mapbox://styles/mapbox/basic-v9",
      "uri": "",
      "id": 0,
      "description": "Basic Layout",
      "active": false
    },
    {
      "name": "Streets",
      "style": "mapbox://styles/mapbox/streets-v9",
      "uri": "",
      "id": 1,
      "description": "Street Layout",
      "active": false
    },
    {
      "name": "Bright",
      "style": "mapbox://styles/mapbox/bright-v9",
      "uri": "",
      "id": 2,
      "description": "Bright Layout",
      "active": false
    },
    {
      "name": "Light",
      "style": "mapbox://styles/mapbox/light-v9",
      "uri": "",
      "id": 3,
      "description": "Light Layout",
      "active": false
    },
    {
      "name": "Dark",
      "style": "mapbox://styles/mapbox/dark-v9",
      "uri": "",
      "id": 4,
      "description": "Dark Layout",
      "active": false
    },
    {
      "name": "FAA Sectional",
      "style": "mapbox://styles/dbinear/cjdcryti9czwa2sq3jpuxkdvf",
      "uri": "",
      "id": 5,
      "description": "FAA Sectional",
      "active": false
    },
    {
      "name": "Satellite",
      "style": "mapbox://styles/mapbox/satellite-v9",
      "uri": "",
      "id": 6,
      "description": "Satellite Layout",
      "active": false
    }] 

export const state = {
     mapStyle:mapLayersTmp[1],
     lngLat:null,
     zoomstart:null,
     zoomend:null,
     drag:null,
     dragend:null,
     click:null,
     styleload:null,
     mapLayers: mapLayersTmp,
     map:null,
     bounds:null
     
}
            
export const mutations ={

    SET_MAP(state,maptype){
        state.map=maptype
    },
    SET_STYLE (state,mstyle){
        state.mapStyle =mstyle;
    },
    SET_MOUSEMOVE (state,g){
        state.lngLat = g;
    },
    SET_ZOOMSTART (state,g){
        state.zoomstart = g;
    },
    SET_ZOOMEND (state,g){
        state.zoomend=g;
    },
    SET_DRAG(state,g){
        state.drag = g;
    },
    SET_DRAGEND(state,g){
        state.dragend = g;
    },
    SET_CLICK(state,g){
        state.click = g;
    },
    SET_STYLELOAD(state,g){
        state.styleload =g;
    },
    SET_MAPLAYERS (state,g){
        state.mapLayers = g
    },
    SET_BOUNDS(state,g){
        state.bounds = g
    }
}
//{ state, commit, rootState }
//{ dispatch, commit, getters, rootGetters }
export const actions = {
    setMap({commit},payload){
        commit('SET_MAP',payload)
    },
    setStyle({commit,state},payload){
      let mstyle=  _.find(state.mapLayers,{id:payload})
      if(mstyle){
          state.map.setStyle(mstyle.style,{diff:false});
          commit('SET_STYLE',mstyle);
      }
    },
    setMouseMove ({commit},payload){
    //    console.log('setMouseMove');
        commit('SET_MOUSEMOVE',payload);
    },
    setZoomStart({commit},payload){
            // console.log('setZoomStart');
        commit('SET_ZOOMSTART',payload);
    },
    setZoomEnd({commit},payload){
        // console.log('setZoomEnd');
        commit('SET_ZOOMEND',payload);
    },
    setDragStart({commit},payload){
        // console.log('setDragStart');
        commit('SET_DRAG',payload);
    },
    setDragEnd({commit},payload){
        // console.log('setDragEnd');
        commit('SET_DRAGEND',payload);
    },
    setClick({commit},payload){
        // console.log('setClick');
        commit('SET_CLICK',payload)
    },
    setStyleLoaded ({commit,payload}){
        // console.log('setStyleLoaded');
        commit("SET_STYLELOAD",payload);
    },
    setMapLayers({commit},payload){
        // console.log('setMapLayers');
        commit('SET_MAPLAYERS',payload);
    },
    setBounds({commit},payload){
        //  console.log('setBounds');
        commit('SET_BOUNDS',payload)
    }
}
 //(state, getters, rootState)
 //(state, getters, rootState, rootGetters) 
export const getters = {
   getMap:(state)=>{
       return state.map
   } ,
   getDefualtStyle:(state)=>{
        return state.mapLayers[0];
   } ,
   getMapById: state => id =>{
       return _.find(state.mapLayers,{id:id})
   },
   getMouseMove:(state)=> {
       if(state.lngLat){
          return state.lngLat
       }
       else{
           return {lng:0,lat:0};
       }
   },
   getMapStyles:(state)=>{
      return state.mapLayers 
   }
}

